import { render, staticRenderFns } from "./TabsSidebarRanking.vue?vue&type=template&id=6d0f9c5a&"
import script from "./TabsSidebarRanking.vue?vue&type=script&lang=js&"
export * from "./TabsSidebarRanking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports